import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopDeleteContentModalProps} from './GiftShopDeleteContentModalProps'

const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: ${convertUnit(295)};
  padding: ${convertUnit(20)};
`

const StyledButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${convertUnit(20)};
  margin-top: ${convertUnit(20)};
`

const StyledButton = styled(Button)`
  flex: 1;
`

const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(8)};
`

export default function GiftShopDeleteContentModal({
  isThisYou,
  onCancel,
  onClick,
}: GiftShopDeleteContentModalProps) {
  const {translate} = useTranslation()

  return (
    <StyledModal visible onBackdropPress={onCancel}>
      <StyledTitle fontSize="xl" fontWeight="bold" lineHeight={42}>
        {translate(isThisYou ? 'global:isThisYou' : 'global:delete')}
      </StyledTitle>
      <Paragraph fontSize="l" lineHeight={31}>
        {translate(
          isThisYou
            ? 'giftShop:creationDeleteItemDescriptionIsThisYou'
            : 'giftShop:creationDeleteItemDescription',
        )}
      </Paragraph>
      <StyledButtonContainer>
        <StyledButton
          label={
            isThisYou
              ? translate('global:notMe')[0].toUpperCase() +
                translate('global:notMe').toLowerCase().substring(1)
              : translate('global:cancel')
          }
          backgroundHoverColor="white_5"
          backgroundColor="white_3"
          color="primary_5"
          onClick={onCancel}
        />
        <StyledButton
          label={translate(isThisYou ? 'global:itsMe' : 'global:delete')}
          onClick={onClick}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
